import LeftMenu from './left-menu'
export default LeftMenu
